import { Archive, ArchiveRestore, PauseCircle, Pencil } from 'lucide-react';

import type { IdeaDetail } from '@/api/types';
import type { RowMenuItem } from '@/ui/RowMenu';

import type { IdeaDetailUi } from './useIdeaDetail';

function triageItems(idea: IdeaDetail, setConfirm: IdeaDetailUi['setConfirm']): RowMenuItem[] {
  if (!idea.permissions.can_triage) return [];
  if (idea.disposition !== 'active') {
    return [{ label: 'Reactivate', icon: <ArchiveRestore aria-hidden="true" />, onSelect: () => setConfirm({ kind: 'disposition', to: 'active' }) }];
  }
  return [
    { label: 'Park', icon: <PauseCircle aria-hidden="true" />, onSelect: () => setConfirm({ kind: 'disposition', to: 'parked' }) },
    { label: 'Archive', icon: <Archive aria-hidden="true" />, onSelect: () => setConfirm({ kind: 'disposition', to: 'archived' }) },
  ];
}

/** The idea's More actions menu: change the industry, and park, archive or reactivate it, as the permissions allow. */
export function ideaMenuItems(idea: IdeaDetail, ui: IdeaDetailUi): RowMenuItem[] {
  const industry: RowMenuItem[] = idea.permissions.can_change_industry
    ? [{ label: 'Change industry', icon: <Pencil aria-hidden="true" />, onSelect: () => ui.setEditingIndustry(true) }]
    : [];
  return [...industry, ...triageItems(idea, ui.setConfirm)];
}
